<template>
  <div>
    <el-form
      ref="form"
      :rules="rules"
      label-width="120px"
      :model="form"
      :hide-required-asterisk="false"
    >
      <el-form-item label="项目名称:" prop="xmbh">
        <el-select
          ref="xmList"
          v-model="form.xmbh"
          placeholder="全部"
          class="filter-item"
          style="width: 100%"
          @change="handleChangeXm"
          :disabled="disabled"
          filterable
        >
          <el-option
            v-for="item in zxlc.xmList"
            :key="item.xmbh"
            :label="item.xmjc"
            :value="item.xmbh"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="收件人:" prop="sjr">
        <el-input
          show-word-limit
          placeholder="请输入收件人姓名"
          maxlength="50"
          v-model="form.sjr"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系方式:" prop="lxfs">
        <el-input
          show-word-limit
          placeholder="请输入联系方式"
          maxlength="50"
          v-model="form.lxfs"
        ></el-input>
      </el-form-item>
      <el-form-item label="收件地址:" prop="sjdz">
        <el-input
          show-word-limit
          placeholder="请输入收件地址"
          maxlength="50"
          v-model="form.sjdz"
        ></el-input>
      </el-form-item>
      <el-form-item label="函件附件" prop="hjfj">
        <div style="display: flex">
          <el-upload
            action="#"
            class="upload-demo"
            ref="uploadApply"
            :headers="headers"
            :on-change="handleChange"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :auto-upload="false"
            multiple
            :limit="1"
          >
            <el-button icon="el-icon-upload" size="small" plain
              >选择附件</el-button
            >
          </el-upload>
          <div
            style="
              margin-left: 15px;
              color: #108ee9;
              text-decoration: underline;
              cursor: pointer;
            "
            v-show="showFile"
            @click="downloadFile()"
          >
            发函模板下载
          </div>
        </div>
        <div class="upload-tips">
          单个文件不能超过20M，仅支持文件扩展名.doc .docx
        </div>
      </el-form-item>
      <el-form-item label="其他备注:" prop="bz">
        <el-input
          show-word-limit
          placeholder="请输入其他备注"
          maxlength="100"
          :rows="3"
          type="textarea"
          v-model="form.bz"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { uploadFile, insertFhsq } from "@/api/zxlc.js";
import { getDict } from "@/api/common.js";
import { mapGetters } from "vuex";
import { validatePhoneTwo } from "@/utils/utils";
const validatePhoneTwoRuler = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("联系方式不能为空"));
  } else {
    if (validatePhoneTwo(rule, value, callback)) {
      callback();
    } else {
      return callback(new Error("联系方式格式不正确"));
    }
  }
};

export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      form: {
        xmbh: null,
        xmmc: null,
        type: 2,
        sjr: null,
        lxfs: null,
        sjdz: null,
        bz: null,
        hjfj: null,
      },
      fileList: [],
      rules: {
        xmbh: [{ required: true, message: "项目不能为空", trigger: "change" }],

        sjr: [{ required: true, message: "收件人不能为空", trigger: "change" }],
        lxfs: [
          // { required: true, message: "联系方式不能为空", trigger: "change" },
          { required: true, validator: validatePhoneTwoRuler, trigger: "blur" },
        ],
        hjfj: [
          {
            required: this.mxParams?.hjfj ? false : true,
            message: "函件附件不能为空",
            trigger: "change",
          },
        ],
        sjdz: [
          { required: true, message: "收件地址不能为空", trigger: "change" },
        ],
      },
      fileUrl: null,
      disabled: false,
      showFile: true,
    };
  },
  created() {
    if (this.mxParams) {
      this.form.xmbh = +this.mxParams.xmbh;
      this.disabled = !!this.mxParams.xmbh;
      if (this.mxParams.sjr) {
        this.showFile = false;
        this.form.sjr = this.mxParams.sjr;
        this.form.lxfs = this.mxParams.lxfs;
        this.form.sjdz = this.mxParams.sjdz;
        this.form.bz = this.mxParams.bz;
      }
    } else {
      this.mxParams = {};
      this.mxParams.xmbh = null;
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        bmbh: null,
      });
    }
    getDict("pmp_zxlc_template_url", 1).then((res) => {
      if (res.code == 0) {
        for (let i of res.data) {
          if (i.dictValue == 2) {
            this.fileUrl = i.dictLabel;
          }
        }
      }
    });
  },
  mounted() {},

  methods: {
    handleChange(file, fileList) {
      //验证上传文件的格式
      const suffixReg = /(doc|docx)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }

      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 20;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload() {
      this.$refs.uploadApply.submit();
      let { uploadFiles } = this.$refs.uploadApply;
      if (this.mxParams?.hjfj) {
        this.form.id = this.mxParams.id;
      }
      if (uploadFiles.length == 0) {
        if (this.mxParams?.hjfj) {
          // 从项目续约发函申请弹窗进入有hjfj id(函件附件id)
          this.form.hjfj = this.mxParams.hjfj;
          this.saveForm();
          return;
        } else {
          this.$message.error("请上传函件附件！");
          return;
        }
      }
      let form = new FormData();
      uploadFiles.forEach((item, index) => {
        form.append("files", item.raw);
      });
      form.append("wjlx", 1);
      form.append("lclx", 2);
      //上传文件
      uploadFile(form).then((res) => {
        if (res.code == 0) {
          this.form.hjfj = res.data;
          this.$message.success("上传成功！");
          this.saveForm();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
            showClose: true,
          });
        }
      });
    },
    saveForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          insertFhsq({ ...this.form }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.$emit("giveFather");
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    handleChangeXm() {
      setTimeout(() => {
        this.form.xmmc = this.$refs.xmList.selected.label;
      }, 10);
    },
    downloadFile() {
      const filePath = this.fileUrl;
      // const
      const len = filePath.split("/").length;
      const fileName = filePath.split("/")[len - 1];
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .vue-treeselect__multi-value-item {
  display: block;
  height: 36px;
  line-height: 36px;
}
::v-deep .vue-treeselect__multi-value {
  height: 40px;
}
</style>